// Hard coded get legend responses
const LEGENDS: Record<string, { value: number; color: string }[]> = {
  jet: [
    { value: 0.0, color: "#00007F" },
    { value: 0.2222222222222222, color: "#0000FE" },
    { value: 0.4444444444444444, color: "#0060FF" },
    { value: 0.6666666666666666, color: "#00D4FF" },
    { value: 0.8888888888888888, color: "#4CFFA9" },
    { value: 1.1111111111111112, color: "#A9FF4C" },
    { value: 1.3333333333333333, color: "#FFE500" },
    { value: 1.5555555555555554, color: "#FF7900" },
    { value: 1.7777777777777777, color: "#FE1100" },
    { value: 2.0, color: "#7F0000" },
  ],
  Blues: [
    {
      value: 0,
      color: "#F7FBFF",
    },
    {
      value: 0.2222222222222222,
      color: "#E1ECF7",
    },
    {
      value: 0.4444444444444444,
      color: "#CBDEF0",
    },
    {
      value: 0.6666666666666666,
      color: "#ABCFE5",
    },
    {
      value: 0.8888888888888888,
      color: "#82BADB",
    },
    {
      value: 1.1111111111111112,
      color: "#58A1CE",
    },
    {
      value: 1.3333333333333333,
      color: "#3787C0",
    },
    {
      value: 1.5555555555555554,
      color: "#1A69AE",
    },
    {
      value: 1.7777777777777777,
      color: "#084C96",
    },
    {
      value: 2,
      color: "#08306B",
    },
  ],
  YlOrRd: [
    {
      value: 0,
      color: "#FFFFCC",
    },
    {
      value: 0.2222222222222222,
      color: "#FFEFA5",
    },
    {
      value: 0.4444444444444444,
      color: "#FEDD80",
    },
    {
      value: 0.6666666666666666,
      color: "#FEBF5A",
    },
    {
      value: 0.8888888888888888,
      color: "#FD9D43",
    },
    {
      value: 1.1111111111111112,
      color: "#FC7033",
    },
    {
      value: 1.3333333333333333,
      color: "#F33C25",
    },
    {
      value: 1.5555555555555554,
      color: "#D9131E",
    },
    {
      value: 1.7777777777777777,
      color: "#B50026",
    },
    {
      value: 2,
      color: "#800026",
    },
  ],
  Purples: [
    {
      value: 0,
      color: "#FCFBFD",
    },
    {
      value: 0.2222222222222222,
      color: "#F0EEF5",
    },
    {
      value: 0.4444444444444444,
      color: "#DFDEED",
    },
    {
      value: 0.6666666666666666,
      color: "#C6C6E1",
    },
    {
      value: 0.8888888888888888,
      color: "#ABA9D1",
    },
    {
      value: 1.1111111111111112,
      color: "#908CC1",
    },
    {
      value: 1.3333333333333333,
      color: "#786EB2",
    },
    {
      value: 1.5555555555555554,
      color: "#64469E",
    },
    {
      value: 1.7777777777777777,
      color: "#51228C",
    },
    {
      value: 2,
      color: "#3F007D",
    },
  ],
  BluGreRed2: [
    {
      value: 0,
      color: "#0B2C7A",
    },
    {
      value: 0.2222222222222222,
      color: "#18768C",
    },
    {
      value: 0.4444444444444444,
      color: "#16A871",
    },
    {
      value: 0.6666666666666666,
      color: "#1DD023",
    },
    {
      value: 0.8888888888888888,
      color: "#87ED01",
    },
    {
      value: 1.1111111111111112,
      color: "#E6DF06",
    },
    {
      value: 1.3333333333333333,
      color: "#ECAB13",
    },
    {
      value: 1.5555555555555554,
      color: "#DC7B25",
    },
    {
      value: 1.7777777777777777,
      color: "#CF6630",
    },
    {
      value: 2,
      color: "#C2523C",
    },
  ],
  Blues_trans0: [
    {
      value: 0,
      color: "#F7FBFF",
    },
    {
      value: 0.2222222222222222,
      color: "#E1ECF7",
    },
    {
      value: 0.4444444444444444,
      color: "#CBDEF0",
    },
    {
      value: 0.6666666666666666,
      color: "#ABCFE5",
    },
    {
      value: 0.8888888888888888,
      color: "#82BADB",
    },
    {
      value: 1.1111111111111112,
      color: "#58A1CE",
    },
    {
      value: 1.3333333333333333,
      color: "#3787C0",
    },
    {
      value: 1.5555555555555554,
      color: "#1A69AE",
    },
    {
      value: 1.7777777777777777,
      color: "#084C96",
    },
    {
      value: 2,
      color: "#08306B",
    },
  ],
  BrOrYe: [
    {
      value: 0,
      color: "#0F2E6F",
    },
    {
      value: 0.2222222222222222,
      color: "#103973",
    },
    {
      value: 0.4444444444444444,
      color: "#124577",
    },
    {
      value: 0.6666666666666666,
      color: "#14517B",
    },
    {
      value: 0.8888888888888888,
      color: "#165D7F",
    },
    {
      value: 1.1111111111111112,
      color: "#186983",
    },
    {
      value: 1.3333333333333333,
      color: "#1A7587",
    },
    {
      value: 1.5555555555555554,
      color: "#1C818B",
    },
    {
      value: 1.7777777777777777,
      color: "#1E8D8F",
    },
    {
      value: 2,
      color: "#83251F",
    },
  ],
  GrRd: [
    {
      value: 0,
      color: "#00CC00",
    },
    {
      value: 0.2222222222222222,
      color: "#2CCC00",
    },
    {
      value: 0.4444444444444444,
      color: "#59CC00",
    },
    {
      value: 0.6666666666666666,
      color: "#88CD00",
    },
    {
      value: 0.8888888888888888,
      color: "#B5CD00",
    },
    {
      value: 1.1111111111111112,
      color: "#CDB600",
    },
    {
      value: 1.3333333333333333,
      color: "#CD8A00",
    },
    {
      value: 1.5555555555555554,
      color: "#CC5C00",
    },
    {
      value: 1.7777777777777777,
      color: "#CC2E00",
    },
    {
      value: 2,
      color: "#CC0000",
    },
  ],
  RdOrYl: [
    {
      value: 0,
      color: "#800026",
    },
    {
      value: 0.2222222222222222,
      color: "#B50026",
    },
    {
      value: 0.4444444444444444,
      color: "#D9131E",
    },
    {
      value: 0.6666666666666666,
      color: "#F33C25",
    },
    {
      value: 0.8888888888888888,
      color: "#FC7033",
    },
    {
      value: 1.1111111111111112,
      color: "#FD9D43",
    },
    {
      value: 1.3333333333333333,
      color: "#FEBF59",
    },
    {
      value: 1.5555555555555554,
      color: "#FEDD80",
    },
    {
      value: 1.7777777777777777,
      color: "#FFEFA5",
    },
    {
      value: 2,
      color: "#FFFFCC",
    },
  ],
  spectral: [
    {
      value: 0,
      color: "#000000",
    },
    {
      value: 0.2222222222222222,
      color: "#6C009C",
    },
    {
      value: 0.4444444444444444,
      color: "#002EDD",
    },
    {
      value: 0.6666666666666666,
      color: "#00A4BB",
    },
    {
      value: 0.8888888888888888,
      color: "#009B12",
    },
    {
      value: 1.1111111111111112,
      color: "#00E100",
    },
    {
      value: 1.3333333333333333,
      color: "#CAF900",
    },
    {
      value: 1.5555555555555554,
      color: "#FFAD00",
    },
    {
      value: 1.7777777777777777,
      color: "#E30000",
    },
    {
      value: 2,
      color: "#CCCCCC",
    },
  ],
};

export function getLegendForStyle(style: string) {
  const values = LEGENDS[style] ?? LEGENDS["jet"];
  const colors = values.map(({ color }) => color).join(",");

  return `linear-gradient(to right, ${colors})`;
}
